import React, { Component } from "react";
import { Animated, View } from "react-native";

export default class Blink extends Component {
  constructor(props) {
    super(props);
    this.fadeAnimation = new Animated.Value(0);
  }

  componentDidMount() {
    this.startAnimation();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.duration !== this.props.duration) {
      this.fadeAnimation.stopAnimation();
      this.startAnimation();
    }
  }

  startAnimation() {
    const onDuration = this.props.duration * 0.8; // On for 80% of the interval
    const offDuration = this.props.duration * 0.2; // Off for 20% of the interval

    Animated.loop(
      Animated.sequence([
        Animated.timing(this.fadeAnimation, {
          toValue: 1, // On (fully visible)
          duration: onDuration,
          useNativeDriver: false,
        }),
        Animated.timing(this.fadeAnimation, {
          toValue: 0, // Off (invisible)
          duration: offDuration,
          useNativeDriver: false,
        }),
      ])
    ).start();
  }

  render() {
    return (
      <View style={{ ...this.props.style }}>
        <Animated.View style={{ opacity: this.fadeAnimation }}>
          {this.props.children}
        </Animated.View>
      </View>
    );
  }
}
